module.exports = __webpack_public_path__ + "e676601848164834ee2f13b6d082fae1.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/food/food3.png
// module id = 2455
// module chunks = 0